import React, { useState } from 'react'
import { X, Calendar } from 'lucide-react'
import { toast } from 'react-toastify'
import { useAuth } from '../../contexts/AuthContext'

const RevisionModal = ({ isOpen, onClose, onSave, currentRevision }) => {
  const { user } = useAuth()
  const [revisionData, setRevisionData] = useState({
    revisionNo: `Rev ${(currentRevision || 1) + 1}`,
    revisionDate: new Date().toISOString().split('T')[0],
    reasonForRevision: '',
    revisionProposedBy: user?.name || '',
    revisionApprovedBy: user?.name || ''
  })

  // Update revision data when user changes or modal opens
  React.useEffect(() => {
    if (isOpen && user?.name) {
      setRevisionData(prev => ({
        ...prev,
        revisionNo: `Rev ${(currentRevision || 1) + 1}`,
        revisionProposedBy: user.name,
        revisionApprovedBy: user.name
      }))
    }
  }, [isOpen, user?.name, currentRevision])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setRevisionData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleDateChange = (e) => {
    setRevisionData(prev => ({
      ...prev,
      revisionDate: e.target.value
    }))
  }

  const validateForm = () => {
    if (!revisionData.reasonForRevision.trim()) {
      toast.error('Reason for Revision is required')
      return false
    }
    if (!revisionData.revisionProposedBy.trim()) {
      toast.error('Revision Proposed by is required')
      return false
    }
    if (!revisionData.revisionApprovedBy.trim()) {
      toast.error('Revision Approved by is required')
      return false
    }
    if (!revisionData.revisionDate) {
      toast.error('Revision Date is required')
      return false
    }
    return true
  }

  const handleSave = () => {
    if (!validateForm()) {
      return
    }
    onSave(revisionData)
    onClose()
  }

  const handleBack = () => {
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="revision-modal-overlay">
      <div className="revision-modal">
        <div className="revision-modal-header">
          <h3>Revision Info</h3>
          <button className="revision-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <div className="revision-modal-content">
          <div className="revision-form">
            <div className="revision-form-row">
              <div className="revision-form-group">
                <label className="revision-form-label required">Revision No.</label>
                <input
                  type="text"
                  name="revisionNo"
                  value={revisionData.revisionNo}
                  onChange={handleInputChange}
                  className="revision-form-input"
                  disabled
                />
              </div>
              
              <div className="revision-form-group">
                <label className="revision-form-label required">Revision Date</label>
                <div className="revision-date-wrapper">
                  <input
                    type="date"
                    name="revisionDate"
                    value={revisionData.revisionDate}
                    onChange={handleDateChange}
                    className="revision-form-input"
                    required
                  />
                  <Calendar size={16} className="revision-calendar-icon" />
                </div>
              </div>
            </div>

            <div className="revision-form-group">
              <label className="revision-form-label required">Reason for Revision</label>
              <textarea
                name="reasonForRevision"
                value={revisionData.reasonForRevision}
                onChange={handleInputChange}
                className="revision-form-textarea"
                placeholder="Enter reason for revision"
                rows="3"
                required
              />
            </div>

            <div className="revision-form-row">
              <div className="revision-form-group">
                <label className="revision-form-label required">Revision Proposed by</label>
                <input
                  type="text"
                  name="revisionProposedBy"
                  value={revisionData.revisionProposedBy}
                  onChange={handleInputChange}
                  className="revision-form-input"
                  placeholder="Enter name"
                  required
                />
              </div>
              
              <div className="revision-form-group">
                <label className="revision-form-label required">Revision Approved by</label>
                <input
                  type="text"
                  name="revisionApprovedBy"
                  value={revisionData.revisionApprovedBy}
                  onChange={handleInputChange}
                  className="revision-form-input"
                  placeholder="Enter name"
                  required
                />
              </div>
            </div>
          </div>
        </div>

        <div className="revision-modal-actions">
          <button className="revision-btn-back" onClick={handleBack}>
            <X size={16} />
            Back
          </button>
          <button className="revision-btn-save" onClick={handleSave}>
            Save & Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default RevisionModal
